<script setup lang="ts"></script>

<template>
  <div class="pb-6">
    <slot></slot>
  </div>
</template>

<style></style>
